// @ts-check

import { ROUTE_NAME } from '@/router/meta'
import { store } from '@/store'

/** @type {import('vue-router').RouteRecordRaw} */
export const DRIVING_LOGS_ROUTE_ROOT = {
  path: '/driving-logs',
  name: 'driving_logs',
  component: () => import('@/views/driving-log/DrivingLogIndex.vue'),
  beforeEnter: (to, from, next) => {
    /**
     * Do not allow couriers to enter driving logs page
     */
    if (store.getters['companyData/isCourier']) {
      next({ name: 'courier', replace: true })
    } else {
      next()
    }
  },
  meta: {
    requiresAuth: true,
    showInMainNav: true,
    icon: '$car-side',
    [ROUTE_NAME]: 'driving_logs'
  }
}

/** @type {import('vue-router').RouteRecordRaw} */
export const DRIVING_LOGS_ROUTE_COURIER = {
  path: '/courier',
  name: 'courier',
  component: () => import('@/views/courier/CourierView.vue'),
  beforeEnter: (to, from, next) => {
    /**
     * Allow only couriers to enter courier page
     */
    if (store.getters['companyData/isCourier']) {
      next()
    } else {
      next({ name: 'driving_logs', replace: true })
    }
  },
  meta: {
    requiresAuth: true,
    showInMainNav: true,
    icon: '$car-side',
    [ROUTE_NAME]: 'courier'
  }
}

/** @type {import('vue-router').RouteRecordRaw} */
export const DRIVING_LOGS_ROUTE_CREATE = {
  path: '/driving-logs/create',
  name: 'driving_logs_create',
  component: () => import('@/views/driving-log/DrivingLogCreateEdit.vue'),
  meta: {
    requiresAuth: true,
    showInMainNav: false,
    [ROUTE_NAME]: 'driving_logs'
  }
}

/** @type {import('vue-router').RouteRecordRaw} */
export const DRIVING_LOGS_ROUTE_EDIT = {
  path: '/driving-logs/:id/edit',
  name: 'driving_logs_edit',
  component: () => import('@/views/driving-log/DrivingLogCreateEdit.vue'),
  meta: {
    requiresAuth: true,
    showInMainNav: false,
    [ROUTE_NAME]: 'driving_logs'
  }
}

/** @type {import('vue-router').RouteRecordRaw[]} */
export const drivingLogRoutes = [
  DRIVING_LOGS_ROUTE_ROOT,
  DRIVING_LOGS_ROUTE_COURIER,
  DRIVING_LOGS_ROUTE_CREATE,
  DRIVING_LOGS_ROUTE_EDIT
]

export default drivingLogRoutes
